'use client';

import { useDebouncedValue } from '@/lib/hooks/use-debounced-value';
import { useGlobalContacts } from '@/lib/services/contacts';
import type { GlobalContact } from '@/lib/services/contacts';

const CONTACT_SEARCH_LIMIT = 5;

export type { GlobalContact };

export function useContactSearch(
  query: string,
  contactsFeatureEnabled: boolean
) {
  const debouncedQuery = useDebouncedValue(query, 300);
  const enabled = contactsFeatureEnabled && debouncedQuery.length >= 2;

  const { data, isLoading } = useGlobalContacts(
    { q: debouncedQuery, limit: CONTACT_SEARCH_LIMIT },
    { enabled }
  );

  return {
    contacts: enabled ? (data?.items ?? []) : [],
    isLoading: enabled && isLoading
  };
}
